import { Location, LocationMapper } from '@nx-smartmonkey/shared/domain';
import { Requests } from '@nx-smartmonkey/shared/helpers';

import { Organization } from '../../domain/organization/Organization';
import { OrganizationDTO } from '../../domain/organization/OrganizationDTO';
import { Project } from '../../domain/project/Project';
import { ProjectDTO } from '../../domain/project/ProjectDTO';
import { OrganizationOnboardingMapper } from '../../mappers/onboarding/OrganizationOnboardingMapper';
import { ProjectOnboardingMapper } from '../../mappers/onboarding/ProjectOnboardingMapper';
import { OrganizationMapper } from '../../mappers/organization/OrganizationMapper';
import { ProjectMapper } from '../../mappers/project/ProjectMapper';
import { SessionRepository } from '../session/SessionRepository';
import { CreateOrganizationOnboardingResponse, OnboardingRepository } from './OnboardingRepository';

export class OnboardingRepositoryApi implements OnboardingRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async initializeOnboarding(plan_name?: string): Promise<CreateOrganizationOnboardingResponse> {
    const response = await this.requests.post({
      uri: `/onboarding/initialize`,
      data: { plan_name },
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    return response.data as CreateOrganizationOnboardingResponse;
  }

  async updateOrganization(organization: Organization): Promise<Organization> {
    const response = await this.requests.put({
      uri: `/onboarding/organization`,
      data: OrganizationOnboardingMapper.toRepository(organization),
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    const updatedOrganization = response.data as OrganizationDTO;

    return OrganizationMapper.toDomain(updatedOrganization);
  }

  async updateProject(project: Project): Promise<Project> {
    const response = await this.requests.put({
      uri: `/onboarding/project`,
      data: ProjectOnboardingMapper.toRepository(project),
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    const updatedProject = response.data as ProjectDTO;

    return ProjectMapper.toDomain(updatedProject);
  }

  async updateOnboardingLocation(location: Location): Promise<void> {
    await this.requests.put({
      uri: `/onboarding/location`,
      data: { location: LocationMapper.toDTO(location) },
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
  }

  async finalizeOnboarding(): Promise<void> {
    await this.requests.post({
      uri: `/onboarding/finalize`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
  }
}
